import styles from './Checkbox.module.scss';

interface ICheckboxProps {
  label: string;
  checked: boolean;
  // eslint-disable-next-line no-unused-vars
  onClick: (isChecked: boolean) => void;
  className?: string;
}

function Checkbox({ label, checked, onClick, className = '' }: ICheckboxProps) {
  const handleChange = () => {
    onClick(!checked);
  };

  return (
    <label className={`${styles.checkbox} ${className}`}>
      <input type="checkbox" checked={checked} onChange={handleChange} />
      <span className={styles.checkmark}></span>
      <span className={styles.labelText}>{label}</span>
    </label>
  );
}

export default Checkbox;
